module.exports = __webpack_public_path__ + "static/media/emailIcon.e7e90cec.svg";